import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Itinerante } from "../../../../services/Itinerante";

export const useItineranteHorariosDisponiveis = (uuidItinerante: string) => {
  const query = useQuery({
    queryKey: ["itinerante-horarios-disponiveis", uuidItinerante],
    queryFn: () => Itinerante.horarios_disponiveis(uuidItinerante),
    select: (response) => response.data,
    enabled: !!uuidItinerante,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
